import React, {useState} from 'react';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const MuiBankCardSelect = ({value, setValue}) => {
  const handleChange = (e) => {
    setValue(e.target.value);
  }
  // console.log(value)
  return (
    <FormControl sx={{ width: "100%", textAlign: "center" }}>
          <FormLabel
            id="demo-row-radio-buttons-group-label"
            sx={{ color: "black", fontWeight: "bold", letterSpacing: "0.1rem" }}
            className="bal-pay-title"
          >
            <p>Or</p>
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={value}
            onChange={handleChange}
          >
            <div className="flex justify-between md:justify-center items-center flex-wrap w-[100%] sm:px-4 card-Option-select">
              <div className="cls_radio_payment">
                <FormLabel>Master</FormLabel>
                <FormControlLabel
                  value="master"
                  sx={{ marginLeft: "14px" }}
                  control={<Radio />}
                />
              </div>
              <div className="cls_radio_payment">
                <FormLabel className="block">Visa</FormLabel>
                <FormControlLabel
                  sx={{ marginLeft: "16px" }}
                  value="visa"
                  control={<Radio />}
                />
              </div>
              <div className="cls_radio_payment">
                <FormLabel className="block">Credit</FormLabel>
                <FormControlLabel
                  sx={{ marginLeft: "16px" }}
                  value="credit"
                  control={<Radio />}
                />
              </div>
              <div className="cls_radio_payment">
                <FormLabel className="block">Debit</FormLabel>
                <FormControlLabel
                  sx={{ marginLeft: "16px" }}
                  value="debit"
                  control={<Radio />}
                />
              </div>
            </div>
          </RadioGroup>
        </FormControl>
  )
}

export default MuiBankCardSelect;